import { useRef, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import cn from '@/utils/cn'
import css from '../cms.module.css'

interface IProps {
  name: string
  value: string
  disabled?: boolean
  error?: boolean
  inscription?: string
  placeholder?: string
  onChange: (value: string, name: string) => void
}

const linkTemplate = '[текст ссылки](https://example.com)'

const MarkdownEditor = (props: IProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const [preview, setPreview] = useState(false)

  const insertLink = () => {
    const textarea = textareaRef.current
    if (!textarea || props.disabled) return

    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    const selectedText = props.value.slice(start, end)
    const linkText = selectedText || 'текст ссылки'
    const nextValue = `${props.value.slice(0, start)}[${linkText}](https://example.com)${props.value.slice(end)}`
    const caretPosition = start + (selectedText ? `[${linkText}](`.length : linkTemplate.length)

    props.onChange(nextValue, props.name)

    window.requestAnimationFrame(() => {
      textarea.focus()
      textarea.setSelectionRange(caretPosition, caretPosition)
    })
  }

  return (
    <div className={css.markdownEditor}>
      <div className={css.markdownToolbar}>
        <div className={css.markdownTabs}>
          <button type="button" data-active={!preview} onClick={() => setPreview(false)}>
            Markdown
          </button>
          <button type="button" data-active={preview} onClick={() => setPreview(true)}>
            Preview
          </button>
        </div>
        <button type="button" onClick={insertLink} disabled={props.disabled}>
          Link
        </button>
      </div>
      {preview ? (
        <div className={cn(css.markdownPreview, 'text-nm')} data-empty={!props.value.trim()}>
          {props.value.trim() ? <ReactMarkdown>{props.value}</ReactMarkdown> : 'Нет текста для предпросмотра'}
        </div>
      ) : (
        <textarea
          ref={textareaRef}
          value={props.value}
          onChange={(ev) => props.onChange(ev.target.value, props.name)}
          disabled={Boolean(props.disabled)}
          data-error={Boolean(props.error)}
          className={cn(css.markdownInput, 'text-nm')}
          placeholder={props.placeholder}
        />
      )}
      {Boolean(props.inscription) && (
        <p className="text-nm text-description" data-error={Boolean(props.error)}>
          {props.inscription}
        </p>
      )}
    </div>
  )
}

export default MarkdownEditor
